<template>
  <div>
    <vs-tooltip text="Bulk Order POs" position="top">
      <vs-dropdown vs-trigger-click>
        <vs-button
          radius
          class="mr-2"
          color="#333f50"
          type="flat"
          icon="picture_as_pdf"
        ></vs-button>
        <vs-dropdown-menu>
          <vs-dropdown-item @click="OrderPOs()">
            Bulk Order POs
            <vs-icon icon="help" class="mr-1" size="15px"></vs-icon>
          </vs-dropdown-item>
          <vs-dropdown-item> Add a Purchase Order </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </vs-tooltip>
    <b-modal id="OrderPOs" centered size="xl">
      <template #modal-title> Pick Vendors </template>
      <template>
        <vs-row>
          <p>Which Assets would you like to associate to the selected parts?</p>
          <vs-spacer></vs-spacer>
          <vs-input
            icon="search"
            placeholder="Search"
            v-model="value1"
            class=""
          />
        </vs-row>
        <br />

        <div style="border: 2px solid grey; height: 30px" class="bg-light mb-1">
          <vs-row>
            <p class="mt-1">
              <vs-icon
                icon="settings"
                size="20px"
                class="mb-1 mr-2 ml-2"
              ></vs-icon
              >Bohler
            </p>
            <vs-spacer></vs-spacer>
            <vs-icon icon="help" class="mt-1 mr-2" size="15px"></vs-icon>
          </vs-row>
        </div>

        <div style="border: 2px solid grey; height: 30px" class="bg-light mb-1">
          <vs-row>
            <p class="mt-1">
              <vs-icon
                icon="settings"
                size="20px"
                class="mb-1 mr-2 ml-2"
              ></vs-icon
              >RS2
            </p>
            <vs-spacer></vs-spacer>
            <vs-icon icon="help" class="mt-1 mr-2" size="15px"></vs-icon>
          </vs-row>
        </div>
      </template>
      <template #modal-footer>
        <vs-row>
          <vs-button
            type="filled"
            style="border-radius: 20px; width: 20%"
            icon="add"
            variant="light"
            >Create Vendor</vs-button
          >
          <vs-spacer />
          <vs-button type="filled" style="border-radius: 20px; width: 10%"
            >Select</vs-button
          >
          <b-button
            id="btncancel"
            class="ml-2"
            variant="light"
            style="border-radius: 20px; width: 10%"
            @click="$bvModal.hide('OrderPOs')"
          >
            Cancle
          </b-button>
        </vs-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value1: "",
    };
  },
  methods: {
    OrderPOs() {
      this.$bvModal.show("OrderPOs");
    },
  },
};
</script>

<style>
</style>